export const FIVE_SECONDS = 5e3;
export const TEN_SECONDS = 1e4;
